import { Observable } from 'rxjs';

import { AppType } from '../../../../types/enums/app/app-type.enum';

/**
 * Interface for the version check service
 */
export abstract class AppActualVersionEnforcer {
    /**
     * Checks if the app needs to be updated by comparing the current version with the version on the server
     * And if so it will show an unclosable modal.
     *
     * @param appType The type of app (client or guard)
     * @returns An Observable that emits true if the app needs to be updated, false otherwise
     */
    abstract execute(appType: AppType): Observable<boolean>;
}
